module.exports = __webpack_public_path__ + "static/media/ticket.7b2316cf.svg";